// src/helpers/rutaCuentasBancarias.js
import axios from "axios";

const BASE_URL = "https://backdanlu.eu-4.evennode.com";
const API_BASE = process.env.REACT_APP_API || BASE_URL;

// Axios instance
const api = axios.create({
  baseURL: API_BASE,
  timeout: 15000,
});

// Token header (tu back usa 'token')
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token") || "";
  if (token) config.headers.token = token;
  return config;
});

// Normaliza error
const parseErr = (e) =>
  e?.response?.data?.msg ??
  e?.response?.data?.err ??
  e?.response?.data?.error ??
  e?.response?.data?.message ??
  e?.message ??
  "Error desconocido";

// Algunas APIs la exponen en singular y otras en plural
const PATHS = ["/cuentabancaria", "/cuentasbancarias", "/cuentas-bancarias"];

/** Devuelve { cuentas: [...] } o { ok:false, msg } */
export const getCuentas = async (params = {}) => {
  let lastErr = null;
  for (const p of PATHS) {
    try {
      const { data } = await api.get(p, { params });
      // Normalizamos la salida para el front:
      if (Array.isArray(data)) return { cuentas: data };
      if (Array.isArray(data?.cuentas)) return data;
      if (Array.isArray(data?.data)) return { cuentas: data.data };
      return data; // por si ya viene con { cuentas }
    } catch (e) {
      lastErr = e;
      // intenta el próximo path
    }
  }
  return { ok: false, msg: parseErr(lastErr) };
};

export default { getCuentas };
